<template><!-- svgo-optimised -->
<svg class="icon icon__wishlist-fill" style="fill: #000000" viewBox="0 0 14 17" xmlns="http://www.w3.org/2000/svg"><path d="M13 1H1v15l5.854-3.841L13 16z" stroke="#000"/></svg>
</template>